import Weekdays from "./Weekdays";
export default Weekdays;
